import React from "react";
import styles from "./styles.css";
import Button from "../../shared/button";
import BetterWayTradeInNew from "../better-way-trade-in-new";
import HowItWorksTradeIn from "../how-it-works-trade-in";
import { redirectToUrl } from "../../../utils/helpers/redirect-to-url";

const TradeInGetOffer = () => {
    const handleGetOffer = () => {
        redirectToUrl({relativeURL: "sell-my-car"});
    };

    return (
        <div styleName={"styles.outer"}>
            <BetterWayTradeInNew />
            <HowItWorksTradeIn/>
            <Button text="GET OFFER" onClick={handleGetOffer} />
        </div>
    );
};

export default TradeInGetOffer;
